import React from "react";
import { EditStateModal } from "../../Modal/EditStateModal";

export function StateEditModal({
  isLoadingEditState,
  handleEditHide,
  isEditModal,
  formikEditState,
  data,
  countryList,
  handleOnClickOfEditModalCancelButton,
}) {
  return (
    <>
      <EditStateModal
        isLoadingEditState={isLoadingEditState}
        handleEditHide={handleEditHide}
        isEditModal={isEditModal}
        data={data}
        countryList={countryList}
        formikEditState={formikEditState}
        handleOnClickOfEditModalCancelButton={handleOnClickOfEditModalCancelButton}
      />
    </>
  );
}
